import { I18nextProvider } from 'react-i18next';
import { useLoaderData, useNavigate } from 'react-router-dom';
import React, { useEffect, useRef } from 'react';
import { createStore, bindActionCreators } from 'redux';
import { connect, Provider } from 'react-redux';
import i18n from './i18n';
import FullBoardReducers from './reducers/full_board.reducers';
import * as FullBoardActions from './actions/full_board.actions';
import FullBoardComp from './components/full_board.component';

const mapsStateToPropsForFullBoard = state => ({
  fullBoard: state,
});

const mapsDispatchToPropsForFullBoard = dispatch => ({
  actions: bindActionCreators(FullBoardActions, dispatch),
});

const FullBoardAppComp = connect(
  mapsStateToPropsForFullBoard,
  mapsDispatchToPropsForFullBoard,
)(FullBoardComp);

// Loader function for React Router
export async function loader() {
  const resp = await fetch('/wb/board/getFullBoardDetails', {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'include',
  });
  if (!resp.ok) throw new Error('Failed to load board details');
  return resp.json();
}

export function FullBoardPage() {
  const data = useLoaderData();
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  // Set min-height on mount
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.style.minHeight = `${window.innerHeight - 126}px`;
    }
  }, []);

  // Handle msteams DOM changes
  useEffect(() => {
    if (data.fromWhere === 'msteams') {
      try {
        document.querySelectorAll('.left-sidebar, .contentRightTop').forEach(el => el.remove());
      } catch { /* intentionally ignore errors */ }
      try {
        document.querySelectorAll('.leftMenuDiv, #mainmenu').forEach(el => el.remove());
        const wbContent = document.querySelector('.wbContent');
        if (wbContent) wbContent.style.paddingTop = '0px';
        setTimeout(() => {
          document.querySelectorAll('.badge-actions-options').forEach(el => el.remove());
        }, 100);
      } catch { /* intentionally ignore errors */ }
    }
  }, [data.fromWhere]);

  // Call trackPendoVisitorReport if enabled
  useEffect(() => {
    if (data.isPendoEnabled && typeof window.trackPendoVisitorReport === 'function') {
      window.trackPendoVisitorReport();
    }
  }, [data.isPendoEnabled]);

  // Set up Redux store
  const store = React.useMemo(() => {
    // Patch for legacy: totalCount expected by reducer
    if (data && data.boardLeftmenuData && data.boardLeftmenuData.workstreams) {
      data.totalCount = data.boardLeftmenuData.workstreams.toalCount;
    }
    return createStore(FullBoardReducers, data);
  }, [data]);

  return (
    <>
      <div id="wsFullBoardWrapper" className="wsFullBoardWrapper" ref={wrapperRef}>
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <FullBoardAppComp navigate={navigate} />
          </I18nextProvider>
        </Provider>
      </div>
      <div id="board_add_board_module" className="hidden" data-board-module={data.boardModule} />
    </>
  );
}
